import {
  ANALYZE_CART_PAGE_VIEW,
  ANALYZE_CLEAR_CART,
  ANALYZE_ITEM_CLICK,
  ANALYZE_ITEM_QUANTITY_CHANGE,
} from './actionTypes';
import {
  AnalyzeCartPageViewAction,
  AnalyzeClearCartAction,
  AnalyzeItemClickAction,
  AnalyzeItemQuantityChangeAction,
} from './types';

export const analyzeCartPageView = (): AnalyzeCartPageViewAction => ({
  type: ANALYZE_CART_PAGE_VIEW,
});

export const analyzeItemClick = (
  sku: string,
  listPosition: number,
): AnalyzeItemClickAction => ({
  type: ANALYZE_ITEM_CLICK,
  payload: {
    sku,
    listPosition,
  },
});

export const analyzeItemQuantityChange = (
  sku: string,
  quantity: number,
  listPosition: number,
): AnalyzeItemQuantityChangeAction => ({
  type: ANALYZE_ITEM_QUANTITY_CHANGE,
  payload: {
    sku,
    quantity,
    listPosition,
  },
});

export const analyzeClearCart = (): AnalyzeClearCartAction => ({
  type: ANALYZE_CLEAR_CART,
});
